<template>
    <div class="row" @click.prevent.stop="onRowClick">
        <div v-for="item in columns" :key="item.key" class="cell" :class="item.cssClass">
            <span class="label">
                <span class="label-title">
                    {{ item.title }}
                    <div class="header-helper" v-if="item.helper">
                        <component :is="item.helper"/>
                    </div>
                </span>
                <span class="label-subtitle" v-if="item.subTitle">{{ item.subTitle }}</span>
            </span>
            <component
                @component-click="onComponentClick"
                class="cell-content"
                :is="item.component"
                :row="row"
            />
        </div>
        <swiper :paginate="true" :space-between="24" v-if="isHome && $root.isMobile">
            <swiper-slide v-for="(items, index) in homeSwiperSlides" :key="index">
                <div v-for="item in items" :key="item.key" class="cell" :class="item.cssClass">
                    <span class="label">
                        <span class="label-title">
                            {{ item.title }}
                            <div class="header-helper" v-if="item.helper">
                                <component :is="item.helper"/>
                            </div>
                        </span>

                        <span class="label-subtitle" v-if="item.subTitle">{{ item.subTitle }}</span>
                    </span>
                    <component
                        @component-click="onComponentClick"
                        class="cell-content"
                        :is="item.component"
                        :row="row"
                    />
                </div>
            </swiper-slide>
        </swiper>
        <div class="cell cell-mobile-nav" v-if="isHome && $root.isMobile">
            <button @click.prevent.stop="onClick">
                Detail
                <right-carat-icon/>
            </button>
        </div>
    </div>
</template>

<script>
import Attendance from 'src/components/GrossesCell/Attendance';
import AttendanceCombined from 'src/components/GrossesCell/AttendanceCombined';
import CapacityPercentage from 'src/components/GrossesCell/CapacityPercentage';
import Gross from 'src/components/GrossesCell/Gross';
import GrossCombined from 'src/components/GrossesCell/GrossCombined';
import GrossPotentialPercentage from 'src/components/GrossesCell/GrossPotentialPercentage';
import PastMonths from 'src/components/GrossesCell/PastMonths';
import Performances from 'src/components/GrossesCell/Performances';
import RightCaratIcon from 'src/components/icons/RightCarat';
import ShowName from 'src/components/GrossesCell/ShowName';
import ShowType from 'src/components/GrossesCell/ShowType';
import TicketAverage from 'src/components/GrossesCell/TicketAverage';
import TicketMax from 'src/components/GrossesCell/TicketMax';
import TicketMin from 'src/components/GrossesCell/TicketMin';
import TicketTop from 'src/components/GrossesCell/TicketTop';
import WeekEnd from 'src/components/GrossesCell/WeekEnd';
import WeekNumber from 'src/components/GrossesCell/WeekNumber';
import Swiper from 'src/components/Swiper';
import SwiperSlide from 'src/components/SwiperSlide';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import kebabCase from 'lodash/kebabCase';
import find from 'lodash/find';
import headers from 'src/config/grosses-table-headers';

export default {
    props: ['row', 'headers', 'isHome'],
    components: {
        Attendance,
        AttendanceCombined,
        CapacityPercentage,
        Gross,
        GrossCombined,
        GrossPotentialPercentage,
        PastMonths,
        Performances,
        RightCaratIcon,
        ShowName,
        ShowType,
        Swiper,
        SwiperSlide,
        TicketAverage,
        TicketMax,
        TicketMin,
        TicketTop,
        WeekEnd,
        WeekNumber,
    },
    computed: {
        columns() {
            return this.headersToComponents(this.headers).filter(col => {
                if (!this.isHome) {
                    return true;
                }

                if (!this.$root.isMobile) {
                    return true;
                }

                return ['show_name', 'past_months'].indexOf(col.key) !== -1;
            });
        },
        homeSwiperSlides() {
            return [
                ['gross_combined', 'gross_potential_percentage'],
                ['attendance_combined', 'capacity_percentage'],
                ['ticket_average'],
            ]
                .map(set => set.map(key => find(headers, { key })))
                .map(set => this.headersToComponents(set));
        },
    },
    methods: {
        headersToComponents(headers) {
            return headers.map(header => ({
                ...header,
                component: upperFirst(camelCase(header.key)),
                cssClass: ['cell-' + kebabCase(header.key)].concat(
                    header.cssClasses || [],
                ),
            }));
        },
        onRowClick() {
            if (this.$root.isMobile) {
                // Ignore full row click on mobile
                return;
            }

            this.onClick();
        },
        onComponentClick(component) {
            if (!this.$root.isMobile) {
                return;
            }

            if (['show-name', 'show-poster'].indexOf(component) > -1) {
                this.onClick();
            }
        },
        onClick() {
            this.$emit('click', this.row);
        },
    },
};
</script>
